import classNames from "classnames";
import {FilterOption} from "../model/types";
import {useCatalogOptionsFilter} from "../model/useCatalogOptionsFilter";
import {CatalogFilterOptionLabel} from "./CatalogFilterOptionLabel";
import {Svg} from "@/shared/ui/Svg";
import styles from "./CatalogOptionsFilterDrawer.module.scss";

type Props = {
    options: FilterOption[];
    visibleOptionsCount?: number;
    loadingOptionId?: number | null;
    onClick: (option: FilterOption) => void;
    insertColors?: Record<string, string>;
    className?: string;
};

export const CatalogOptionsFilterDrawer = (
    {
        options,
        visibleOptionsCount = 8,
        loadingOptionId = null,
        onClick,
        insertColors,
        className,
    }: Props
) => {
    const preparedOptions = useCatalogOptionsFilter({options, visibleOptionsCount});

    const containerClassNames = classNames(styles.list, className);

    return (
        <div className={containerClassNames}>
            {preparedOptions.map((option) => {
                const checkboxContainerClassName = classNames(styles.checkboxContainer, className, {
                    [styles.active]: Boolean(option.checked),
                    [styles.disabled]: Boolean(option.disabled),
                    [styles.hidden]: option.hidden
                });

                return (
                    <div key={option.id} className={checkboxContainerClassName} onClick={() => onClick(option)}>
                        <p className={styles.checkboxTitle}>
                            <CatalogFilterOptionLabel option={option} insertColors={insertColors} />
                        </p>
                        {Boolean(option.checked) && (<Svg id={`dagger-close`} className={styles.iconClose} />)}
                        {loadingOptionId === option.id && (<span className={styles.spinner} />)}
                    </div>
                );
            })}
        </div>
    );
}
